import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();

export function redirect(url: string) {
    history.push(url);
}
